import { render, staticRenderFns } from "./SkillRatting.vue?vue&type=template&id=0698e5f6&scoped=true"
import script from "./SkillRatting.vue?vue&type=script&lang=js"
export * from "./SkillRatting.vue?vue&type=script&lang=js"
import style0 from "./SkillRatting.vue?vue&type=style&index=0&id=0698e5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698e5f6",
  null
  
)

export default component.exports